<script>
  import { createEventDispatcher, getContext } from "svelte"
  import StorageUnit from "./StorageUnit.svelte"

  const dispatch = createEventDispatcher()
  const { xScale, yScale } = getContext("LayerCake")
  const { createDomainPointerEvent } = getContext("ContainerPointerHandler")

  export let storageUnitTypesById
  export let storageUnitRow
  export let selected

  let width
  let height

  function getRowDimensions(storageUnitRow) {
    const dimensions = { height: 0, width: 0 }

    storageUnitRow.storageUnits.forEach((unit) => {
      const unitType = storageUnitTypesById.get(unit.typeId)
      const unitHeight = unitType.shape.height

      dimensions.height = Math.max(dimensions.height, unitType.shape.height)
      dimensions.width += unitType.shape.width
    })

    return dimensions
  }

  function transformStorageUnits(storageUnitRow) {
    const y = 0
    let x = 0

    const rowDimensions = getRowDimensions(storageUnitRow)
    height = rowDimensions.height
    width = rowDimensions.width

    return storageUnitRow.storageUnits.map((storageUnit) => {
      const obj = { x, y, storageUnit }
      const storageUnitType = storageUnitTypesById.get(storageUnit.typeId)

      if (storageUnitRow.align == "end") {
        obj.y = height - storageUnitType.shape.height
      }

      x += storageUnitType.shape.width

      return obj
    })
  }

  $: storageUnitsAndPositions = transformStorageUnits(storageUnitRow)

  let gTransform
  $: gTransform = `translate(${$xScale(storageUnitRow.position.x)}, ${$yScale(storageUnitRow.position.y)}) rotate(${storageUnitRow.rotation})`

  function handlePointerEvent(e) {
    const { type, detail } = createDomainPointerEvent(e, "storageUnitRow", storageUnitRow.id)
    dispatch(type, detail)
  }
</script>

<g
  transform={gTransform}
  on:pointerdown|stopPropagation={handlePointerEvent}
  on:pointermove|stopPropagation={handlePointerEvent}
>
  {#each storageUnitsAndPositions as sup}
    <StorageUnit
      x={sup.x}
      y={sup.y}
      storageUnit={sup.storageUnit}
      {storageUnitTypesById}
      storageUnitRowSelected={selected}
    />
  {/each}
</g>
